import { useState, useEffect } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import FloatingContactButtons from "../components/FloatingContactButtons";
import { FaArrowUp } from "react-icons/fa";

const MainLayout = ({ children }) => {
  const [darkMode, setDarkMode] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);

  // Persist dark mode in localStorage
  useEffect(() => {
    const savedMode = localStorage.getItem("darkMode");

    if (savedMode === "true") {
      setDarkMode(true);
    }
  }, []);

  // Apply/remove dark class to <html> and save preference
  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }

    localStorage.setItem("darkMode", darkMode);
  }, [darkMode]);

  // Show scroll-to-top button on scroll
  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div
      className={`flex flex-col min-h-screen transition-colors duration-500 ${
        darkMode
          ? "bg-gray-900 text-gray-200"
          : "bg-gray-50 text-gray-900"
      }`}
    >
      {/* Navbar */}
      <Navbar
        darkMode={darkMode}
        toggleDarkMode={toggleDarkMode}
      />

      {/* Main Content */}
      <main className="flex-1 transition-colors duration-500">
        <div className="animate-fade-in">
          {children}
        </div>
      </main>

      {/* Footer */}
      <Footer darkMode={darkMode} />

      {/* Floating Contact Buttons */}
      <FloatingContactButtons />

      {/* Scroll-to-top button */}
      {showScrollTop && (
        <button
          type="button"
          onClick={scrollToTop}
          aria-label="Scroll to top"
          className={`
            fixed
            bottom-6 right-6
            z-50
            flex h-12 w-12
            items-center justify-center
            rounded-full
            shadow-lg
            transition-all duration-300
            hover:-translate-y-1
            hover:shadow-xl
            focus:outline-none
            focus:ring-2
            focus:ring-offset-2
            dark:focus:ring-offset-gray-900
            ${
              darkMode
                ? "bg-orange-500 text-white hover:bg-orange-600 focus:ring-orange-400"
                : "bg-blue-600 text-white hover:bg-blue-700 focus:ring-blue-500"
            }
          `}
        >
          <FaArrowUp aria-hidden="true" />
        </button>
      )}
    </div>
  );
};

export default MainLayout;